import React from 'react'
import { Link } from 'react-router-dom'

import logo from '../images/gordon_logo.svg'
import versionInfo from '../version.json'
import { FooterLogo, FooterRoot, FooterText, FooterLink } from '../styles/components/FooterStyle'

const Footer = () => {
  return (
    <FooterRoot className="sticky-vertical">
      <FooterLogo src={logo} alt="Logo" />
      <FooterLink component={Link} to="/privacy" variant="body2">
        Privacy Policy
      </FooterLink>
      <FooterText variant="body2">Version {versionInfo.version}</FooterText>
    </FooterRoot>
  )
}

export default Footer
